"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventBackendFactory = void 0;
const EventsBackendType_1 = require("../EventsBackendType");
const EventsBackendKinesis_1 = require("./EventsBackendKinesis");
const EventsBackendNull_1 = require("./EventsBackendNull");
class EventBackendFactory {
    static getBackend(eventConfig) {
        switch (eventConfig.backendType) {
            case EventsBackendType_1.EventsBackendType.KINESIS:
                if ("streamUrl" in eventConfig.backendConfig) {
                    return new EventsBackendKinesis_1.EventsBackendKinesis(eventConfig.backendConfig.streamUrl);
                }
                else {
                    throw new Error("Missing streamUrl in `eventConfig`");
                }
            case EventsBackendType_1.EventsBackendType.DEV_NULL:
                return new EventsBackendNull_1.EventsBackendNull();
            default:
                throw new Error("Unknown event backend `eventConfig`");
        }
    }
}
exports.EventBackendFactory = EventBackendFactory;
//# sourceMappingURL=EventBackendFactory.js.map